import { render, staticRenderFns } from "./ShowNameDialog.vue?vue&type=template&id=24a7e7f6&scoped=true&"
import script from "./ShowNameDialog.vue?vue&type=script&lang=js&"
export * from "./ShowNameDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a7e7f6",
  null
  
)

export default component.exports